import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ILogger {
    debug(message: string): void {
        this.captureMessage(message, 'debug')
    }

    info(message: string): void {
        this.captureMessage(message, 'info');
    }

    warning(message: string): void {
        this.captureMessage(message, 'warning');
    }

    error(message: string): void {
        this.captureMessage(message, 'error');
    }

    fatal(message: string): void {
        this.captureMessage(message, 'fatal')
    }

    setUser(user: Sentry.User | null){
        if(environment['sentryDsn'])
            Sentry.setUser(user);
    }

    private captureMessage(message: string, level: Sentry.SeverityLevel){
        if(environment['sentryDsn'])
            Sentry.captureMessage(message, level);
    }
}